export default __webpack_public_path__ + "static/media/8fcbc7db-082c-4503-8e47-2bce2c143b62.9569060e.JPG";